import API from "../http-helper.service";

export default class ReviewPortalService {
  getTurbinesForSite(siteId) {
    return API.get("builder/assetMgmt/turbines?siteId=" + siteId);
  }

  getAllFormNames() {
    return API.get("builder/forms/getFormName", { includeUserId: true });
  }

  getAllGroups() {
    return API.get("category?categoryType=Group");
  }

  getAllUsers() {
    return API.get("user-mgmt/users");
  }

  getAllFormsBySortingorSearching(
    searchQuery,
    sortParameter,
    currentPage,
    rowsPerPageSize,
  ) {
    let page = currentPage > 0 ? currentPage - 1 : currentPage;
    let baseUrl =
      "filler/formData/filter?page=" + page + "&size=" + rowsPerPageSize;
    if (sortParameter) {
      if (sortParameter.value && sortParameter.value !== "") {
        baseUrl =
          baseUrl + "&sort=" + sortParameter.value + "," + sortParameter.order;
      }
    }
    return API.post(baseUrl, searchQuery).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }
  getAllUsersListAutoComplete(searchQuery) {
    return API.get(`user-mgmt/users/userlist/${searchQuery}`).then(
      (res) => {
        let item = [];
        if (res.data) {
          item = res.data.map((val) => {
            return {
              id: val.sso,
              label: `${val.userFirstName} ${val.userLastName}(${val.sso})`,
              email: val.email,
            };
          });
        }
        return item;
      },
      (error) => {
        return error;
      },
    );
  }
  approveTransferForm(formObject) {
    let configData = { includeUserId: true };
    let baseUrl = "filler/formData/transferFormData";
    return API.post(baseUrl, formObject, configData).then(
      (res) => {
        return res;
      },
      (err) => {
        let error;
        error = err.response ? err.response : error;
        return error;
      },
    );
  }

  getAllFormsBySearching(searchQuery) {
    let baseUrl = "filler/formData/export-csv";
    return API.post(baseUrl, searchQuery).then(
      (res) => {
        return res;
      },
      (error) => {
        return error;
      },
    );
  }

  getSavedUserFilters = () => {
    let baseUrl = "filler/formData/userpreferences";
    return API.get(baseUrl, { includeUserId: true }).then(
      (res) => {
        return res?.data;
      },
      (error) => {
        return error;
      },
    );
  };

  saveUserFilters = (payload) => {
    const baseUrl = "filler/formData/userpreferences";
    return API.post(baseUrl, payload, { includeUserId: true }).then(
      (res) => {
        return res?.data;
      },
      (error) => {
        return error;
      },
    );
  };
}
